import * as DialogPrimitive from '@radix-ui/react-dialog'
import { useLayoutEffect, useState } from 'react'

type DialogPortalProps = {
  children: React.ReactNode
}
/**
 * This component wraps Radix's Portal implementation to handle SSR issues
 * as well as portalling to the wrong body element when rendering in an iframe.
 */
export function DialogPortal(props: DialogPortalProps) {
  const { children } = props
  const [tempNode, setTempNode] = useState<HTMLElement | null>(null)
  const [portalNode, setPortalNode] = useState<HTMLElement | null>(null)

  useLayoutEffect(() => {
    if (!tempNode) return

    const portalNode = tempNode.ownerDocument.body

    setPortalNode(portalNode)
  }, [tempNode])

  return portalNode
    ? (
        <DialogPrimitive.Portal container={portalNode}>
          {children}
        </DialogPrimitive.Portal>
      )
    : (
        <span
          ref={(el) => {
            if (el) setTempNode(el)
          }}
        />
      )
}
